export function typeName(o: unknown): string {
  if (Array.isArray(o)) {
    // Extract the first 11 elements
    // and use the array.from to iterate over all the entries
    const length = o.length;
    if (length <= 500) {
      let type: string | null = null;
      for (let i = 0; i < length; i++) {
        let curType;
        const val = o[i];
        if (!(i in o)) curType = "[empty]";
        else if (Array.isArray(val)) curType = "[Array]";
        else if (typeof val === "function") curType = "[function]";
        else curType = typeName(val);
        if (type == null) type = curType;
        if (type != curType) {
          type = null;
          break;
        }
      }
      if (type == null) return `[Array(${length})]`;
      return `[Array(${length}) ${type}]`;
    } else {
      return `[Array(${length})]`;
    }
  }
  if (typeof o === "function") {
    if (o.name) return `[function ${o.name}]`;
    return "[anonymous function]";
  }
  if (typeof o !== "object") return `[${typeof o}]`;
  if (o === null) return "[null]";
  return Object.prototype.toString.call(o);
}
